module.exports = __webpack_public_path__ + "static/media/avatar-basic-silver.36ad401f.svg";